import { render } from "./CategoryCreateView.vue?vue&type=template&id=bc4f2656&scoped=true"
import script from "./CategoryCreateView.vue?vue&type=script&lang=js"
export * from "./CategoryCreateView.vue?vue&type=script&lang=js"

import "./CategoryCreateView.vue?vue&type=style&index=0&id=bc4f2656&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc4f2656"]])

export default __exports__